import { useQueryHelper } from '@anytag/shared-hooks';

export const AuthorizedPage = () => {
  const { t } = useQueryHelper();

  return (
    <div className="flex min-h-screen items-center justify-center bg-black-10">
      <div className="flex flex-col items-center rounded-lg bg-white p-8 shadow-md">
        <div className="mb-4 text-xl font-semibold text-primary">{t('SlackAuthorizePage.AuthorizedPageMessage')}</div>
        <span>{t('SlackAuthorizePage.WorkflowEnded')}</span>
      </div>
    </div>
  );
};
